import React from 'react';
import { ClassAssembly3A2026 } from '../views';


const ClassAssemblyPage = () => {
    return <ClassAssembly3A2026/>;
  };
  
  export default ClassAssemblyPage;